<template>
  <Multipane
    class="DataLayout-vertical Custom-resizer-vertical"
    layout="vertical"
    @paneResizeStop="invalidateSize"
  >
    <div class="DataLayout-sidebarWrapper-vertical pr-2">
      <div class="d-flex flex-row mb-2">
        <h2 class="flex-grow-1">Assets</h2>
        <b-button class="" variant="outline-primary" @click="createAsset">
          <i class="fa fa-plus" />
          Create New Asset</b-button
        >
      </div>
      <TableView
        id="tableView"
        ref="tableView"
        controller="device-manager/asset"
        collection="assets"
        dataType="asset"
        add-item-label="Add an asset"
        stickyHeader="100%"
        :hide-edit-action="true"
        :hide-create-action="true"
        :index="selectedTenant.index"
        :show-on-map-action="true"
        @show-on-map="showOnMap"
        @fetched="fetched"
      >
      </TableView>
    </div>
    <MultipaneResizer></MultipaneResizer>
    <div class="DataLayout-contentWrapper-vertical">
      <Map
        ref="map"
        id="assetMap"
        :markers="markers"
        @boundsUpdated="boundsUpdated"
      />
    </div>
    <!-- <CreateUpdateAssetModal></CreateUpdateAssetModal> -->
  </Multipane>
</template>

<script>
import { ref } from '@vue/composition-api';
import get from 'lodash/get';
import { mapGetters } from 'vuex';
import TableView from '@/components/device-manager/TableView';
import Map from '@/components/device-manager/Map';
import { Multipane, MultipaneResizer } from 'vue-multipane';
// import CreateUpdateAssetModal from '@/components/device-manager/asset/CreateUpdateAssetModal';

export default {
  components: {
    // CreateUpdateAssetModal,
    Map,
    Multipane,
    MultipaneResizer,
    TableView
  },
  computed: {
    ...mapGetters('tenants', ['selectedTenant'])
  },
  setup() {
    const markers = ref([]);
    const map = ref(null);
    const assetList = ref(null);

    return {
      markers,
      map,
      assetList,
      fetched: items => {
        markers.value = [];
        for (const item of items) {
          if (get(item, 'measures.position.point', false)) {
            markers.value.push({
              _id: item._id,
              coords: {
                lat: item.measures.position.point.lat,
                lng: item.measures.position.point.lon
              },
              popupData: {
                model: item.model,
                reference: item.reference,
                type: item.type
              }
            });
          }
        }
      },
      invalidateSize: () => {
        map.value.invalidateSize();
      },
      boundsUpdated: val => {
        assetList.value.fetchItems(val);
      },
      showOnMap: pos => {
        if (!pos) {
          this.$log.warn(
            'Unable to locate item on the map: position is undefined'
          );
          return;
        }
        map.value.map.mapObject.setView(new L.LatLng(pos.lat, pos.lon), 13);
      },
      createAsset() {
        this.$refs.tableView.createRow();
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.DataLayout-vertical {
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.DataLayout-sidebarWrapper-vertical {
  min-width: 50vh;
  width: 50%;
  height: 100%;
  z-index: 1;
}
.DataLayout-contentWrapper-vertical {
  min-width: 5vh;
  flex-grow: 1;
  height: 100%;
  overflow: auto;
}
.Custom-resizer-vertical > .multipane-resizer {
  margin: 0;
  left: 0;
  position: relative;
  padding: 3px;
  border: 1px solid #ccc;
  box-shadow: 2px 0px 5px -2px rgba(112, 112, 112, 1);
  &:before {
    display: block;
    content: '';
    width: 1px;
    height: 50px;
    position: absolute;
    top: 45%;
    left: 50%;
    border-left: 1px solid #aaa;
  }
  &:hover {
    &:before {
      border-color: #777;
      background-color: #f5f5f5;
    }
  }
}
</style>

<style lang="scss">
#assetList .overflow-auto {
  max-height: 65vh;
  overflow: auto;
}
</style>
